<template>
        <v-row class="align-center">
            <!-- Left Title (if provided) -->
            <v-col v-if="leftTitle" class="text-right font-weight-bold text-h6" :class="{ 'text-info': !switchValue }">
                {{ leftTitle }}
            </v-col>

            <!-- Switch -->
            <v-col cols="auto" class="pa-0">
                <v-switch
                    v-model="switchValue"
                    hide-details
                    density="compact"
                    v-auto-animate
                    inset
                />
            </v-col>

            <!-- Right Title (if provided) -->
            <v-col v-if="rightTitle" class="text-left font-weight-bold text-h6" :class="{ 'text-info': switchValue }">
                {{ rightTitle }}
            </v-col>
        </v-row>

</template>

<script>
export default {
    props: {
        modelValue: Boolean, // Bind v-model externally
        leftTitle: String, // Left label
        rightTitle: String, // Right label
    },
    computed: {
        switchValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },
};
</script>
